<script setup lang="ts">
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { FieldStyle, PartialDisplayType } from "@/builder/enums";
import { useRenderStore } from "@/builder/stores/renderStore";
import { computed, inject, PropType, Ref } from "vue";
import { PageDesign } from "../page/PageInterface";
import { IBusinessNameInputCustomData, ITextInputComponent } from "./TextInputInterface";

const renderStore = useRenderStore();

const props = defineProps({
    component: {
        type: Object as PropType<ITextInputComponent>,
        required: true,
    },
});

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

const isModalDisplay = computed(() => {
    return renderStore.page.partialDisplayType === PartialDisplayType.Modal;
});

const customData = computed(() => {
    return props.component.customData as IBusinessNameInputCustomData;
});
</script>

<template>
    <div class="form-row name-container" :class="isModalDisplay ? 'rd-mb-2.5' : 'rd-mb-3.5'">
        <ValidatedInput :id="component.id" :value="renderStore.donor.organizationName" :label="customData.label"
            name="Donor.OrganizationName" class="rd-w-full"
            :class="{ 'form-compact-full': fieldStyle == FieldStyle.Compact }"
            :isRequired="component.customData.required" :maxLength="75">
            <template #input="inputProps">
                <input type="text" v-model="renderStore.donor.organizationName" :placeholder="customData.placeholder"
                    :aria-describedby="inputProps.describedBy ?? undefined"
                    :id="component.id + '_Donor.OrganizationName'" autocomplete="organization" />
            </template>
        </ValidatedInput>
    </div>
    <div class="form-element-wrapper rd-relative rd-mt-2">
        <input type="checkbox" id="onBehalfOfText" class="rd-relative" v-model="renderStore.donor.isOrganization">
        <label for="onBehalfOfText" class="rd-mb-0 rd-ml-2.5">{{ customData.onBehalfOfText }}</label>
    </div>
</template>
